import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=ec815d98&scoped=true"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=ec815d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec815d98",
  null
  
)

export default component.exports